import { render, staticRenderFns } from "./imageItem.vue?vue&type=template&id=5da3122e&scoped=true"
import script from "./imageItem.vue?vue&type=script&lang=js"
export * from "./imageItem.vue?vue&type=script&lang=js"
import style0 from "./imageItem.vue?vue&type=style&index=0&id=5da3122e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da3122e",
  null
  
)

export default component.exports